import React, { Component } from "react";
import ImageDiv from "./ImageDiv";
import MainText from "./MainText";

class Subpage extends Component {
  render() {
    return (
      <div className="layout-page subpage">
        {/* this scene has a title, some action buttons, stored in an array, with type data, visual elements (how many? what type?) stored in an array, with type data, and data about next available scenes, stored in an array */}
        <div className="flex-box flex-center">
          <div className="column-lg-12 column-sm-12 column-md-12">
            <h2><span className="title">{this.props.content.title}</span></h2>
          </div>
        </div>
        {/* top div */}
   
        <div className="flex-box">
          <div className="flex-column column-lg-6 column-sm-12 column-md-12">
            <ImageDiv
              columns={`column-lg-10 column-sm-10 column-md-12`}
              image={this.props.content.leadImage}
            />
          </div>
          <div className="flex-column flex-center space-atop column-lg-6 column-md-12 column-sm-12">
              <h3> <span className="banner-heading">{'>>'} What we did</span></h3>
            <MainText
              className={`text-div text-shadow`}
              text={this.props.content.description}
            />
          </div>
        </div>
        {/* end top div */}
        <div className="flex-column flex-center space-atop">
          <h3> <span className="banner-heading">{'>>'} Outcomes</span></h3>
          <div className="column-lg-10 column-md-12 column-sm-12 text-shadow">
            <ul className="outcome-list">
              {this.props.content.outcomes.map((outcome, i) => {
                return <li key={i}>{outcome}</li>;
              })}
            </ul>
          </div>
        </div>
        <div className="flex-box flex-center gallery space-atop">
          {this.props.content.gallery.map((image, i) => {
            return <ImageDiv columns={`column-lg-4 column-md-12 column-sm-12 blue`} image={image} key={i} />;
          })}
        </div>

        <div className="flex-column flex-center space-atop column-lg-10 column-md-12 column-sm-12">
        <h3> <span className="banner-heading">{'>>'} Future directions</span></h3>
            <MainText className={`text-div text-shadow`} text={this.props.content.future}/>
        </div>
        <div className="flex-box flex-end space-atop">
          <button onClick={this.props.back} className="button">
           &larr; back to prototypes
          </button>
        </div>
      </div>
    );
  }
}

export default Subpage;
